import { containersApi } from './api';

const baseURI = '/warehouse';

export const WarehouseApi = {
  //send 'Y' if you want to filter only inventory warehouses
  getWarehouseLocations: (inventoryLocation = null) => {
    return containersApi.get(
      `${baseURI}?inventoryLocation=${inventoryLocation}`
    );
  },
};
